import { render, staticRenderFns } from "./AdminVue.vue?vue&type=template&id=ae1f54ea&"
import script from "./AdminVue.vue?vue&type=script&lang=js&"
export * from "./AdminVue.vue?vue&type=script&lang=js&"
import style0 from "./AdminVue.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports